require("../js/webformscompat");
global.eduutils = require("../js/eduutils");
global.luvitedu = require("../js/edu_frameset.js");
global.LMSAPI = require("../../Education/SCORM/LMSAPI");
global.LMSAPI2004 = require("../../Education/SCORM/LMSAPI2004");
import "../../../../node_modules/jquery-ui-dist/jquery-ui";
global.passPolicy = require("../../../../node_modules/password-policy");
require("../js/plugins/jquery.touchSwipe.min.js");
require("../js/plugins");
require("../js/lib/features");
// force load ckeditor on all webforms pages.
let ckeditorConfig = require("../js/config/ckeditor-config");
require("../../ckeditor45/ckeditor.js");
ckeditorConfig.setup();
